import React from 'react'
import './styles.css'

const FilterLoader = () => {
  return (
    <span className="loader"></span>
  )
}

export default FilterLoader